<template>
  <div class="product-main-block-component">
    <ym-block v-for="(block, index) in list"
              :key="index"
              :title="block.blockTitle"
              :more="block.showMore"
              :explore="block.explore"
              @click-more="handleShowMore"
    >
      <grid v-if="showGird(block.viewMode) || showCard(block.viewMode)"
            :list="block.list"
            :show-swiper="block.viewMode !== 'fullScreenGrid'"
            :show-card-grid="showCard(block.viewMode)"
            :options="generateSwiperOptions(block.viewMode)"
            :size="gridSize(block.viewMode)"
            :empty-string="emptyString"
            :show-title="block.viewMode !== 'fullScreenGrid'"
            :show-summary="block.viewMode !== 'smallGrid'"
            :record-type="recordType"
            :block-title="block.blockTitle"
            :custom-collection-type="customCollectionType"
      />
      <list v-else
            type="block"
            :list="block.list"
            :show-empty="showEmpty"
            :empty-string="emptyString"
            :record-type="recordType"
            :block-title="block.blockTitle"
            :show-price="showPrice"
            :custom-collection-type="customCollectionType"
      />
    </ym-block>
  </div>
</template>

<script>
  import Block from '@/components/Block';
  import Grid from '@/components/ProductGrid/List';
  import List from '@/components/ProductList/List';
  import { commonLog } from '@/services/app';
  import { upperCaseFirst } from '@/utils';

  export default {
    name: 'ProductMainList',
    components: {
      'ym-block': Block,
      Grid,
      List,
    },
    data() {
      return {
        smallGridOption: {
          slidesPerView: 'auto',
          spaceBetween: 15,
        },
        largeGridOption: {
          loop: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          spaceBetween: 15,
        },
      };
    },
    props: {
      mainBlock: {
        type: Array,
        required: true,
      },
      options: {
        type: Object,
      },
      showEmpty: Boolean,
      emptyString: {
        type: String,
        default: '暂无课程',
      },
      recordType: {
        type: String,
        validator(val) {
          return [
            'main',
            'audio',
            'course',
            'courseNew',
            'parent',
            'learning',
            'studentGains',
            'customCollection',
          ].includes(val);
        },
      },
      showPrice: {
        type: Boolean,
        default: true,
      },
      customCollectionType: {
        type: String,
        default: '',
      },
    },
    computed: {
      list() {
        return this.mainBlock.filter(block => block.list.length > 0);
      },
    },
    methods: {
      generateSwiperOptions(mode) {
        switch (mode) {
          case 'smallGrid': {
            return Object.assign(this.smallGridOption, this.options);
          }
          case 'largeGrid': {
            return Object.assign(this.largeGridOption, this.options);
          }
          default:
            return this.options;
        }
      },
      showGird(mode) {
        return [
          'smallGrid',
          'largeGrid',
          'fullScreenGrid',
        ].includes(mode);
      },
      showCard(mode) {
        return [
          'cardGrid',
        ].includes(mode);
      },
      gridSize(mode) {
        return mode.replace('Grid', '');
      },
      showProductIndex(type) {
        const name = `${upperCaseFirst(type)}`;
        const route = { name };
        this.$router.push(route);
      },
      showProductList(type, query) {
        const name = `${upperCaseFirst(type)}List`;
        const route = { name, query };
        this.$router.push(route);
      },
      handleShowMore(explore) {
        const { listToIndex, type, query } = explore;
        switch (type) {
          case 'audio':
          case 'combo':
          case 'course':
          case 'project': {
            if (listToIndex) {
              this.showProductIndex(type);
              return;
            }
            this.showProductList(type, query);
            return;
          }
          default: {
            commonLog('ProductMainListTypeError', type);
          }
        }
      },
    },
  };
</script>
